import React, { useState } from 'react';
import { Row, Col, Drawer, Typography, Spin } from 'antd';
import '../Restaurant/Restaurant.css';
import Back from '../../assests/Back.svg';
import { useSelector } from 'react-redux';

const WaiterDetails = (props) => {
  const { drawerVisible, setDrawerVisible } = props;
  const [width] = useState(window.innerWidth);
  const handleCloseDrawer = () => {
    setDrawerVisible(false);
  };
  const { Waiter, isGetWaiterByIdLoading } = useSelector((state) => {
    const { Waiter, isGetWaiterByIdLoading } = state.waiter;
    return {
      Waiter,
      isGetWaiterByIdLoading,
    };
  });

  return (
    <Drawer
      closeIcon={<img src={Back} alt='props' />}
      closable={false}
      title={
        <div>
          <Row>
            <Col span={2}>
              <img
                src={Back}
                alt='props'
                onClick={handleCloseDrawer}
                style={{ cursor: 'pointer' }}
              />
            </Col>
            <Col span={22}>
              <Typography className='drawerHeading'>Show</Typography>
            </Col>
          </Row>
        </div>
      }
      placement='right'
      onClose={handleCloseDrawer}
      open={drawerVisible}
      width={width > 400 ? '400px' : '100%'}
    >
      {Waiter && (
        <Spin spinning={isGetWaiterByIdLoading}>
          <Row gutter={[16, 16]} className='button'>
            <Col span={24}>
              <Typography className='detailheading'>First name</Typography>
              <Typography className='detailsubheading'>
                {Waiter?.first_name}
              </Typography>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className='button'>
            <Col span={24}>
              <Typography className='detailheading'>Last name</Typography>
              <Typography className='detailsubheading'>
                {Waiter?.last_name}
              </Typography>
            </Col>
          </Row>
          <Row gutter={[16, 16]} className='button'>
            <Col span={24}>
              <Typography className='detailheading'>Code</Typography>
              <Typography className='detailsubheading'>
                {Waiter?.waiter_code}
              </Typography>
            </Col>
          </Row>
        </Spin>
      )}
    </Drawer>
  );
};
export default WaiterDetails;
